module.exports = __webpack_public_path__ + "media/images/zoomify_undo-67a3d26e92fd656a91ed86c94c9eeb8c.png";